var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClaim = function SvgClaim(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 21",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 .5c.392 0 .75.153 1.018.402.266.247.444.588.477.97h0L17.5 8.5h-1v-7h-15V17a1.5 1.5 0 001.357 1.493h0L6.5 18.5V19.5H2a1.498 1.498 0 01-1.495-1.37h0L.51 2c0-.394.15-.754.398-1.023.243-.264.58-.439.962-.471h0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 1a1.44 1.44 0 00-1.03.425c-.251.25-.43.607-.47 1.05h0v.525H12l-.147.007c-.34.033-.646.18-.884.418-.245.246-.421.592-.469 1.075 0 .397.153.758.425 1.03.25.251.607.43 1.05.47h0l.525.5.007.147c.033.34.18.646.418.884.246.245.592.421 1.075.469a1.44 1.44 0 001.03-.425c.251-.25.43-.607.47-1.05h0l.5-.525.147-.007c.34-.033.646-.18.884-.418.245-.246.421-.592.469-1.075a1.44 1.44 0 00-.425-1.03 1.677 1.677 0 00-1.05-.47h0L15.5 14l-.007-.147a1.436 1.436 0 00-.418-.884c-.246-.245-.592-.421-1.075-.469z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClaim);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/claim.99846bc66ca57bf7a7f9d0a161ee3fea.svg";